import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const BOOTCAMP_URL = "/bootcamp";
const ELECTRIC = "#00BFFF";

const GAINS = [
  "Cessez d'être le goulot d'étranglement de votre propre boîte. On installe votre cockpit de pilotage en 30 jours.",
  "Automatisez vos processus chronophages avec l'IA.",
  "Reprenez la souveraineté sur votre organisation.",
];

/* Decorative HUD corner brackets */
function CornerBrackets() {
  const stroke = ELECTRIC;
  return (
    <>
      <svg className="absolute top-4 left-4 sm:top-6 sm:left-6 pointer-events-none" width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
        <path d="M1 8V1H8" stroke={stroke} strokeWidth="1.5" />
      </svg>
      <svg className="absolute top-4 right-4 sm:top-6 sm:right-6 pointer-events-none" width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
        <path d="M21 8V1H14" stroke={stroke} strokeWidth="1.5" />
      </svg>
      <svg className="absolute bottom-4 left-4 sm:bottom-6 sm:left-6 pointer-events-none" width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
        <path d="M1 14V21H8" stroke={stroke} strokeWidth="1.5" />
      </svg>
      <svg className="absolute bottom-4 right-4 sm:bottom-6 sm:right-6 pointer-events-none" width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
        <path d="M21 14V21H14" stroke={stroke} strokeWidth="1.5" />
      </svg>
    </>
  );
}

export default function FeaturedOfferBanner() {
  return (
    <section
      className="relative bg-[#0a0e14] text-pearl overflow-hidden border-t border-b border-[#1a2233]"
      data-testid="featured-offer-banner"
    >
      {/* Blueprint grid pattern */}
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-[0.10] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,191,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(0,191,255,0.5) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />
      {/* Top horizontal scan-line accent */}
      <div
        aria-hidden="true"
        className="absolute top-0 left-0 right-0 h-px"
        style={{
          background:
            "linear-gradient(90deg, transparent 0%, #00BFFF 25%, #00BFFF 75%, transparent 100%)",
        }}
      />
      {/* Glow */}
      <div
        aria-hidden="true"
        className="absolute -top-32 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(closest-side, rgba(0,191,255,0.18), transparent)",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-10 py-20 sm:py-24">
        <CornerBrackets />

        {/* HUD header line */}
        <div className="flex items-center gap-3 mb-10" data-testid="featured-offer-overline">
          <span
            className="block w-2 h-2 rounded-full animate-pulse"
            style={{ backgroundColor: ELECTRIC, boxShadow: `0 0 10px ${ELECTRIC}` }}
          />
          <span className="font-mono text-[10px] sm:text-xs tracking-[0.28em] uppercase" style={{ color: ELECTRIC }}>
            //  SYSTÈME 01  ·  SESSION EXCLUSIVE  ·  10 ENTREPRENEURS UNIQUEMENT
          </span>
          <span className="flex-1 h-px bg-[#1a2a3d]" />
          <span className="font-mono text-[10px] tracking-[0.2em] text-pearl/40 hidden sm:inline">
            REC · 30 JOURS
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          {/* LEFT: Cockpit headline + CTA */}
          <div className="lg:col-span-7">
            <div className="font-mono text-xs tracking-[0.22em] text-pearl/40 uppercase mb-5">
              // Bootcamp B2B
            </div>

            <h2
              className="font-mono font-bold text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight uppercase mb-8"
              data-testid="featured-offer-hook"
            >
              <span className="text-pearl block">Bootcamp B2B</span>
              <span
                className="block"
                style={{
                  color: ELECTRIC,
                  textShadow: `0 0 24px rgba(0,191,255,0.35)`,
                }}
              >
                Pilote en 30 jours.
              </span>
            </h2>

            <p className="font-mono text-base sm:text-lg text-pearl/75 uppercase tracking-[0.05em] leading-relaxed mb-10">
              Reprenez le contrôle.{" "}
              <span className="text-pearl font-semibold">10 places exclusives.</span>
            </p>

            <Link
              to={BOOTCAMP_URL}
              className="group inline-flex items-center gap-4 px-8 py-5 font-mono font-bold text-sm tracking-[0.2em] uppercase transition-all"
              style={{
                backgroundColor: ELECTRIC,
                color: "#0a0e14",
                boxShadow: `0 0 0 1px ${ELECTRIC}, 0 0 32px rgba(0,191,255,0.35)`,
              }}
              data-testid="featured-offer-cta"
            >
              <span>{"C'est quoi exactement ?"}</span>
              <span
                className="flex items-center justify-center w-6 h-6 transition-transform group-hover:translate-x-1"
                style={{ backgroundColor: "#0a0e14", color: ELECTRIC }}
              >
                <ArrowUpRight size={14} strokeWidth={2.5} />
              </span>
            </Link>

            <div className="mt-6 flex items-center gap-3 text-xs font-mono tracking-wider text-pearl/45">
              <span
                className="w-1.5 h-1.5 rounded-full"
                style={{ backgroundColor: "#FF3B30" }}
              />
              <span>STATUS · CANDIDATURES OUVERTES · 497€</span>
            </div>
          </div>

          {/* RIGHT: 3 Gains Immédiats — terminal style */}
          <div className="lg:col-span-5">
            <div className="relative border border-[#1a2a3d] bg-[#0d1320]/60 backdrop-blur-sm">
              {/* Panel header */}
              <div className="flex items-center justify-between px-5 py-3 border-b border-[#1a2a3d]">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-[#FF3B30]/80" />
                  <span className="w-2 h-2 rounded-full bg-[#D4AF6A]/80" />
                  <span
                    className="w-2 h-2 rounded-full"
                    style={{ backgroundColor: ELECTRIC }}
                  />
                </div>
                <span className="font-mono text-[10px] tracking-[0.22em] uppercase text-pearl/50">
                  03_gains_immediats.log
                </span>
              </div>

              {/* Gains list */}
              <ul className="p-6 sm:p-8 space-y-5" data-testid="featured-offer-gains">
                {GAINS.map((gain, i) => (
                  <li key={gain} className="flex items-start gap-4">
                    <span className="flex-shrink-0 mt-0.5 font-mono text-xs text-pearl/40 tabular-nums">
                      0{i + 1}
                    </span>
                    <span
                      className="flex-shrink-0 text-base leading-none mt-0.5"
                      style={{ color: ELECTRIC, filter: "drop-shadow(0 0 6px rgba(0,191,255,0.45))" }}
                      aria-hidden="true"
                    >
                      ✓
                    </span>
                    <span className="text-pearl text-sm sm:text-base leading-snug">
                      {gain}
                    </span>
                  </li>
                ))}
              </ul>

              {/* Panel footer */}
              <div className="px-5 py-3 border-t border-[#1a2a3d] flex items-center justify-between">
                <span className="font-mono text-[10px] tracking-[0.22em] uppercase text-pearl/40">
                  Output verified
                </span>
                <span
                  className="font-mono text-[10px] tracking-[0.22em] uppercase"
                  style={{ color: ELECTRIC }}
                >
                  ▸ READY
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
